import type { IntlShape } from 'react-intl';

import { ErrorKeySet, type ValidationError, type Validator } from '../../../types/field-validation';
import type { FormFieldValidation } from '../../../types/form/form-fields';
import type { TextValue } from '../../../types/form/form-fields/field-values';
import { getTextValidationErrors } from '../text';
import { getFailedValidationError } from '../utils';
import { messages } from './messages';

const emailRegex = /[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*/;

export const getEmailFormatErrors = (
	intl?: IntlShape,
	textValue?: TextValue,
): ValidationError[] => {
	const text = textValue?.text?.trim();
	if (text && !emailRegex.test(text)) {
		return [
			getFailedValidationError(ErrorKeySet.INVALID, intl?.formatMessage(messages.invalidEmail)),
		];
	}
	return [];
};

export const getEmailValidationErrors = (
	validation: FormFieldValidation,
	fieldLabel: string,
	intl?: IntlShape,
	textValue?: TextValue,
): ReturnType<Validator> => {
	if (textValue) {
		const { text } = textValue;
		const trimmedText = text.trim();

		if (!emailRegex.test(trimmedText)) {
			return [
				getFailedValidationError(ErrorKeySet.INVALID, intl?.formatMessage(messages.invalidEmail)),
			];
		}
	}

	return getTextValidationErrors(validation, fieldLabel, intl, textValue);
};
